<template>
  <section>
    <div class="promotion-user-outer">
      <div class="promotion-user-inner">
        <h1 class="promotion-user-hd">감사합니다.</h1>
        <p class="promotion-user-txt">
          <span>해지 신청이 취소되었습니다.</span>
          <span>다음 정기 결제일에 100원 결제됩니다.</span>
        </p>
        <span class="promotion-user-image">
          <img src="../../assets/images/img-crm-m.png" alt="100원">
        </span>
        <a href="#" @click.prevent="goHome" class="promotion-user-link">확인</a>
      </div>
    </div>
  </section>
</template>
<script>
import utils from '@/common/util/utils'
import { DEVICE_TYPE_ANDROID } from '@/common/devicetype.const'
import { PATH_NAME_HOME } from '@/common/router.const'

export default {
  methods: {
    goHome () {
      const device = utils.cookies.getDevice()
      if (device === DEVICE_TYPE_ANDROID) {
        window.Android.ClosePopupAndReload()
      } else {
        this.$router.replace({ name: PATH_NAME_HOME })
      }
    }
  }
}
</script>
<style scoped>
  .promotion-user-outer{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    min-height: 500px;
  }
  .promotion-user-inner{
    flex: 1;
    padding: 0 20px;
    text-align: center;
    color: #fff;
  }
  .promotion-user-image{
    display: block;
    width: 275px;
    margin: 42px auto 60px;
  }
  .promotion-user-image img{
    display: block;
    max-width: 100%;
  }
  .promotion-user-hd{
    margin-bottom: 8px;
    font-size: 20px;
    line-height: 28px;
  }
  .promotion-user-txt{
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }
  .promotion-user-txt span{
    display: block;
  }
  .promotion-user-link{
    display: block;
    max-width: 480px;
    padding: 12px 0;
    margin: 40px auto 0;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
    background-color: #00bbec;
    border-radius: 24px;
  }
</style>
